import { Route } from 'react-router-dom';

import { PropertyGroupDetailPage } from './pages/property-group-detail-page.js';
import { PropertyGroupFormPage } from './pages/property-group-form-page.js';
import { PropertyGroupListPage } from './pages/property-group-list-page.js';

export function propertyGroupRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/property-groups" element={<PropertyGroupListPage />} />
      <Route path="/property-groups/new" element={<PropertyGroupFormPage />} />
      <Route path="/property-groups/:propertyGroupId/edit" element={<PropertyGroupFormPage />} />
      <Route path="/property-groups/:propertyGroupId" element={<PropertyGroupDetailPage />} />
    </>
  );
}
